import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const APP_URL = 'https://constructi6448.builtwithrocket.new';

const QRCodeSection = () => {
  const [activeTab, setActiveTab] = useState('both');

  const tabs = [
    { id: 'both', label: 'Both' },
    { id: 'ios', label: 'iPhone' },
    { id: 'android', label: 'Android' },
  ];

  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="text-center mb-4">
        <h2 className="text-base font-semibold text-foreground">Scan to Install</h2>
        <p className="text-xs text-muted-foreground mt-1">
          Point your device camera at the QR code to open the install page
        </p>
      </div>
      {/* Tab selector */}
      <div className="flex justify-center mb-5">
        <div className="inline-flex bg-muted rounded-lg p-1 gap-1">
          {tabs?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => setActiveTab(tab?.id)}
              className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
                activeTab === tab?.id
                  ? 'bg-background text-foreground shadow-sm'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              {tab?.label}
            </button>
          ))}
        </div>
      </div>
      {/* QR Codes */}
      <div className={`flex gap-6 justify-center ${
        activeTab === 'both' ? 'flex-row flex-wrap' : 'flex-col items-center'
      }`}>
        {/* iOS QR Code */}
        {(activeTab === 'both' || activeTab === 'ios') && (
          <div className="flex flex-col items-center gap-3">
            <div className="bg-white p-3 rounded-xl shadow-sm border border-border">
              <QRCodeSVG
                value={APP_URL}
                size={140}
                bgColor="#ffffff"
                fgColor="#000000"
                level="M"
                includeMargin={false}
              />
            </div>
            <div className="text-center">
              <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-gray-900 text-white rounded-full text-xs font-medium">
                <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                iPhone / iOS
              </div>
              <p className="text-xs text-muted-foreground mt-1.5">Open in Safari, then&lt;br/&gt;tap Share → Add to Home Screen</p>
            </div>
          </div>
        )}

        {/* Android QR Code */}
        {(activeTab === 'both' || activeTab === 'android') && (
          <div className="flex flex-col items-center gap-3">
            <div className="bg-white p-3 rounded-xl shadow-sm border border-border">
              <QRCodeSVG
                value={APP_URL}
                size={140}
                bgColor="#ffffff"
                fgColor="#000000"
                level="M"
                includeMargin={false}
              />
            </div>
            <div className="text-center">
              <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-green-700 text-white rounded-full text-xs font-medium">
                <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.523 15.341l-.002-.001c-.008-.004-.016-.009-.024-.013l-2.108-1.217a.506.506 0 00-.506 0l-2.49 1.438a.506.506 0 01-.506 0l-2.49-1.438a.506.506 0 00-.506 0L6.783 15.327c-.008.004-.016.009-.024.013l-.002.001A.506.506 0 006.5 15.78v2.434c0 .186.1.357.26.45l4.98 2.875a.506.506 0 00.506 0l4.98-2.875a.506.506 0 00.26-.45V15.78a.506.506 0 00-.263-.439zM12 2a10 10 0 100 20A10 10 0 0012 2zm0 3.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm3.5 10.5h-7a.5.5 0 010-1h7a.5.5 0 010 1z"/>
                </svg>
                Android
              </div>
              <p className="text-xs text-muted-foreground mt-1.5">Open in Chrome, tap menu&lt;br/&gt;then "Add to Home Screen"</p>
            </div>
          </div>
        )}
      </div>
      {/* URL display */}
      <div className="mt-5 pt-4 border-t border-border text-center">
        <p className="text-xs text-muted-foreground">Install URL</p>
        <p className="text-xs font-mono text-foreground mt-0.5 break-all">{APP_URL}</p>
      </div>
    </div>
  );
};

export default QRCodeSection;
